import React from "react";
import "./Core_team.css";
// import Common_title from '../../common-components/common-title/Common_title'
import { Link } from "react-router-dom";

const Core_team = () => {
  return (
    <>
      <section className="Core_team_section">
        <div className="container">
       <div className="core-title text-center">
  <p className="subheading">CORE TEAM</p>
  <h2 className="heading">Experts Who Took an Initiative</h2>
</div>

          <div className="row mt-5 justify-content-center">
            <div className="col-md-4 col-sm-6 mb-4">
              <div className="team_member_card">
                <div className="image_div">
                  <img
                    className="memberimg"
                    src={
                      process.env.PUBLIC_URL +
                      "/assets/images/about_us/core-team/team1.png"
                    }
                    alt="Team Member 1"
                  />
                </div>
                <div className="overlay"></div>
                <div className="member_info">
                  <h6 className="name">Harshal Subhash Ukirde</h6>
                  <p className="position">Founder & CEO</p>
                  <div className="d-flex justify-content-center icondiv">
                    <Link
                      to="https://www.facebook.com/people/URBAN-PRIME-MART/61572599274761/#"
                      target="_blank"
                    >
                      <img
                        className="icon"
                        src={
                          process.env.PUBLIC_URL +
                          "/assets/images/about-us/core-team/facebook.png"
                        }
                      />
                    </Link>

                    <Link
                      to="https://www.instagram.com/urbanprimemart?igsh=ZXpqNmpmd2Y3MWcz&utm_source=qr"
                      target="_blank"
                    >
                      <img
                        className="icon"
                        src={
                          process.env.PUBLIC_URL +
                          "/assets/images/about-us/core-team/instagram.png"
                        }
                      />
                    </Link>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-md-4 col-sm-6 mb-4">
              <div className="team_member_card">
                <div className="image_div">
                  <img
                    className="memberimg"
                    src={
                      process.env.PUBLIC_URL +
                      "/assets/images/about_us/core-team/team2.png"
                    }
                    alt="Team Member 1"
                  />
                </div>
                <div className="overlay"></div>
                <div className="member_info">
                  <h6 className="name">Subhash Mahadu Ukirde</h6>
                  <p className="position">Director(Sourcing & Logistics)</p>
                  <div className="d-flex justify-content-center icondiv">
                    <Link>
                      <img
                        className="icon"
                        src={
                          process.env.PUBLIC_URL +
                          "/assets/images/about-us/core-team/instagram.png"
                        }
                      />
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Core_team;
